import { render, staticRenderFns } from "./epms4030.vue?vue&type=template&id=04a0ca62&scoped=true"
import script from "./epms4030.vue?vue&type=script&lang=js"
export * from "./epms4030.vue?vue&type=script&lang=js"
import style0 from "./epms4030.vue?vue&type=style&index=0&id=04a0ca62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0ca62",
  null
  
)

export default component.exports